import { AppRoutes } from '@/constants/appRoutes'
import type { StepGuardEvalContext } from '@/hooks/createStepGuard'
import { ESignUpStep } from '@/pages/SignUp/types'
import type { SignUpSliceState } from '@/store/api/SignUp/SignUp.slice'
import { signUpSliceInitialState } from '@/store/api/SignUp/SignUp.slice'

const hasCredentials = (slice: SignUpSliceState['userAuth']) =>
  !!slice && slice.email !== signUpSliceInitialState.userAuth.email

type Predicate = (
  evalContext: StepGuardEvalContext<SignUpSliceState['userAuth']>,
) => boolean

export const STEP_PREREQUISITES: Record<ESignUpStep, Predicate> = {
  [ESignUpStep.FirstStep]: ({ slice }) => hasCredentials(slice),
  [ESignUpStep.SecondStep]: ({ slice }) => hasCredentials(slice),
  [ESignUpStep.FinalStep]: ({ slice }) => hasCredentials(slice),
}

export const STEP_FALLBACK_ROUTE: Record<ESignUpStep, AppRoutes> = {
  [ESignUpStep.FirstStep]: AppRoutes.login,
  [ESignUpStep.SecondStep]: AppRoutes.login,
  [ESignUpStep.FinalStep]: AppRoutes.login,
}
